import React from 'react';
import { connect } from 'react-redux';

import S from 'constants/string.const';
import { withIsFromMobileApp } from 'hooks/useIsFromMobileApp.hook';
import { withGilt, withTranslation } from 'providers/GILT.provider';

import HeaderMenu from 'reports/Common/HeaderMenu';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import { Tables } from 'reports/consts';
import Hours from 'reports/HoursWorked/Hours.component';

import { SalonHoursWorkedByCategoryOrServiceTable } from './SalonHoursWorkedByCategoryOrServiceTable';
import StylistHoursByCategoryAndServiceContainer from './StylistHoursByCategoryAndService';

const ReportsProps = ['salonHoursReport'];

export class HoursWorkedReports extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: props.t('businessReports.hours.title'),
        items: [
          {
            id: Tables.WorkingHoursStylist,
            name: props.t('businessReports.hours.staff'),
            onClick: () => {
              this.setTables(Tables.WorkingHoursStylist);
            },
          },
          {
            id: Tables.HoursWorkedByCategory,
            name: props.t('businessReports.hours.category'),
            onClick: () => {
              this.setTables(Tables.HoursWorkedByCategory);
            },
          },
          {
            id: Tables.HoursWorkedByStylistByCategoryAndService,
            name: props.t('businessReports.hours.staffMemberPerCategoryService'),
            onClick: () => {
              this.setTables(Tables.HoursWorkedByStylistByCategoryAndService);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.setTables(Tables.WorkingHoursStylist);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const { uniqueVisitsReport, t, formatDate } = this.props;
    return (
      <div className="has-protipbox hours">
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          <HeaderMenu data={this.state.headerData} selectedId={this.state.shownTables} />
          {this.props.salonHoursReport.lastRequestResponse && (
            <div className="box hours">
              <div className="banner default full-width hour">
                <div style={{ width: '100%' }}>
                  <div className="cfix relative">
                    <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                      {S.lamp}
                    </span>
                    <div className="text">
                      <strong>{t('businessReports.hours.proTip')}</strong>
                      {t('businessReports.hours.proTipDescription1')}
                    </div>
                  </div>
                  <div className="cfix relative">
                    <span className="img-emoji-2" role="img" aria-labelledby="lamp">
                      {S.lamp}
                    </span>
                    <div className="text">
                      <strong>{t('businessReports.hours.proTip')}</strong>
                      {t('businessReports.hours.proTipDescription2')}
                    </div>
                  </div>
                </div>
                {!this.props.isFromMobile && (
                  <div className="link">
                    <a href="https://help.getslick.com/en/articles/1703114-all-you-need-to-know-about-staff-time-off" alt="Heed help" target="_blank" rel="noopener noreferrer">
                      {t('businessReports.hours.needHelp')}
                    </a>
                  </div>
                )}
              </div>
              <div className="title" style={{ marginTop: '18px' }}>{`${this.state.title}`}</div>

              <Hours
                startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
              />

              {!!(this.state.shownTables & Tables.HoursWorkedByCategory) && (
                <SalonHoursWorkedByCategoryOrServiceTable
                  startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                  endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                  data={this.props.salonHoursReport.lastRequestResponse}
                  type="Category"
                />
              )}

              {!!(this.state.shownTables & Tables.HoursWorkedByStylistByCategoryAndService) && (
                <StylistHoursByCategoryAndServiceContainer
                  startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                  endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                  data={this.props.salonHoursReport.lastRequestResponse}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
  } = state;
  const { salonHoursReport, stylistIDInCalendarOrder, uniqueVisitsReport } = reports;
  return {
    salonId,
    stylistList,
    salonHoursReport,
    stylistIDInCalendarOrder,
    uniqueVisitsReport,
  };
}

export function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withIsFromMobileApp(withGilt(withTranslation()(HoursWorkedReports))));
